package com.dotpx.ambient

enum class TextureKind {
    Wind,
    Rain,
    Surf,
    Forest,
    Fire,
    Water,
    Train,
    Steam,
    Room,
    Brook,
    Waterfall,
    Blizzard,
    Ventilation,
    DistantTraffic,
    BoatEngine,
    BrownNoise,
}

enum class EventKind {
    None,
    Bird,
    InsectCall,
    Drip,
    Bell,
    Metal,
    Creak,
    Spark,
    Relay,
    Frog,
    Thunder,
    Radio,
    TrainJoint,
    Beep,
    Rock,
    WaveSlap,
    Higurashi,
    Dove,
    WindChime,
    Owl,
    Cricket,
    Bubble,
    FootstepGravel,
    FootstepSnow,
    BranchSnap,
    ClockTick,
    BuoyBell,
    LeafDrip,
    BicyclePass,
}
